// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { useBunzlDispatch } from "@store/Framework/Store/Bunzl/BunzlReducer";
import { toToolkitApplicationState } from "@toolkit/Framework/Store/ApplicationState";
import { useSelector } from "react-redux";

const useProductDetailsZoomState = () => {
    const isZoomOpen = useSelector(
        (state: ApplicationState) => toToolkitApplicationState(state).bunzl.pages.productDetailsZoom.isZoomOpen,
    );
    const bunzlDispatch = useBunzlDispatch();
    const setZoomOpen = (isZoomOpen: boolean) =>
        bunzlDispatch({ type: "Store/Pages/productDetailsZoom/setIsZoomOpen", isZoomOpen });
    return [isZoomOpen, setZoomOpen] as const;
};

export default useProductDetailsZoomState;
